<template>
  <div v-if="theModel">
    <!-- all charts have this -->
    <div class="row no-wrap full-width" style="gap: 4px;">
      <MostaSelect
        v-model="widthModel"
        class="q-mb-xs"
        style="flex: 1 1 0; min-width: 0;"
        :options="widthOptions"
      />
      <MostaSelect
        v-model="elementWidthModel"
        class="q-mb-xs"
        style="flex: 1 1 0; min-width: 0;"
        :options="elementWidthOptions"
      />
    </div>

    <!-- v-if="sectorModel && sectorModel.length && sector_index >= 0 && sector_index < sectorModel.length" -->
    <MostaSelect
      v-model="axisModel"
      v-show="false"
      class="q-mb-xs"
      :label="$t('path_to_file')"
      :options="axisOptions"
    />

    <element-options-settings-panel
      v-if="hasAnalyticElementOptions"
      v-model="theModel.Options"
    />

    <div class="row justify-left full-width q-py-xs no-wrap">
      <q-btn
        class="q-my-none unset-items-center" flat dense round icon="add" size="sm" color="grey-8"
        @click="addNewGElement"
        :aria-label="$t('add_pie_sector')"
      >
        
      </q-btn>
      <div class="col q-py-none">
        <div class="text-h8 text-bold q-mb-none" style="margin-top: 2px;">
          {{ $t('pie_sectors') }}
        </div>
      </div>
    </div>

    <div v-if="sectorModel">
      <q-chip v-for="(sector, index) in sectorModel"
        removable
        square
        :key="sector.Id"
        icon-selected="none"
        icon-remove="delete"
        :selected="selectedId === sector.Id"
        @click="() => { selectedId = sector.Id; tempName = sector.Name; }" 
        :style="`background-color: ${sector_index === index ? '#F0F0F0' : '#FFFFFF'};`"
        text-color="grey-9"
        class="cursor-pointer full-width no-icon-chip"
        @remove="deleteGElement(index)"
      >
        <template v-slot:default>
          <div class="row justify-center no-wrap full-width">
            <div class="q-mr-xs" style="overflow-x: hidden; max-width: 80% !important;">
              {{ sector.Name }}
            </div>
            <q-btn
              class="q-my-none q-mx-xs q-pa-none"
              flat
              dense
              color="grey-7"
              :aria-label="$t('rename')"
              icon="edit"
              size="xs"
              @click.stop.prevent
              @mousedown.stop.prevent
              @mouseup="(e: any) => { renameBtnClick(index) }"
            >
              <q-tooltip :delay="300" anchor="top middle" self="center middle">
                {{ $t('rename') }}
              </q-tooltip>
              <!-- v-model="isEditingMode" -->
              <!-- @keydown.esc="isEditingMode = false" -->
              <q-menu fit style="max-width: 400px;"
                anchor="bottom end" self="top middle" :ref="(el: any) => { menus[index] = el }">
                <div class="row justify-center q-ma-xs">
                  <q-input autogrow autofocus color="white" :ref="(el: any) => { inputs[index] = el }"
                    debounce="500" multiline dense outlined hide-bottom-space
                    v-model="tempName" no-error-icon :placeholder="$t('name')"
                    :rules="[(val: string) => !!val || $t('input_name')]"
                    @keydown.enter.stop.prevent="(val: any) => { renameGElement(index); }"
                  />
                  <q-item-section>
                    <q-btn
                      class="q-my-none q-ml-xs q-pa-none unset-items-center"
                      flat
                      dense
                      round
                      color="grey-7"
                      bg-color="transparent"
                      @click="renameGElement(index)"
                      :aria-label="$t('apply_changes')"
                      icon="done"
                      size="sm"
                      v-close-popup
                    >
                      <q-tooltip :delay="300" anchor="top middle" self="center middle">
                        {{ $t('apply_changes') }}
                      </q-tooltip>
                    </q-btn>
                  </q-item-section>
                </div>
              </q-menu>
            </q-btn>
            <q-space />
            <q-btn
              class="q-my-none q-mx-xs q-pa-none"
              flat
              dense
              color="grey-7"
              :aria-label="$t('clone')"
              icon="content_copy"
              size="xs"
              @click.stop.prevent="cloneGElement(index)"
            >
              <q-tooltip :delay="300" anchor="top middle" self="center middle">
                {{ $t('clone') }}
              </q-tooltip>
            </q-btn>
          </div>
        </template>
      </q-chip>
      <div v-if="sectorModel && sectorModel.length && sector_index >= 0 && sector_index < sectorModel.length">
        <div class="text-h8 text-bold q-mt-md">
          {{ $t('pie_settings') }}
        </div>

        <MostaSelect
          v-if="!isEvaluateFormulas && !isReportSegment"
          v-model="sectorAnalyzedModel"
          class="q-mb-xs q-mx-none"
          option-label="Name"
          :label="$t('analyzed_element')"
          :options="genstore.analyzedListForChart"
        />

        <div v-if="isPieChart" class="text-h8 text-bold q-mt-md q-mb-none">{{ $t('func_label') }}</div>
        <enum-display-list v-if="isPieChart" :elements="evaluateToList" :enum-to-string="EvaluateFunctionToStr" 
          :allow-multiple="false" :combobox="false" :element-type="8" v-model="evaluateModel"/>

        <div class="q-my-xs"
        v-if="(isPieChart) && isEvaluateFormulas && !isReportSegment"
        >
          <formulas-list
            :use-chart-mode="true" :parameter-options="graphstore.getCurrentFormulas"
            nested-key-name="ChildFormulas" template-name="Entity"
            v-model="(sectorModel[sector_index] as ClientProjectSectorTypes).Formulas"
            @changePosition="moveFormulaItem"
          />
        </div>

        <mosta-tree-select
          v-if="(isPieChart) && isEvaluateParameter"
          ref="param_select_base"
          :display-text="baseParameterModelStr"
          :placeholder="$t('select_parameter')"
          :content-max-height="300"
          @update:search="(val) => { filter_string = val; }"
          @keyDown="$refs.rec_selector_base && $refs.rec_selector_base.trackArrowDown(1)"
          @keyUp="$refs.rec_selector_base && $refs.rec_selector_base.trackArrowUp(1)"
          @keyEnter="$refs.rec_selector_base && $refs.rec_selector_base.selectCurrent()"
        >
          <recursive-selector
            ref="rec_selector_base"
            :elements="(theModel as ClientProjectPieTypes).Parameters"
            :take-ids-only="true"
            :allow-multiple="false"
            :element-type="1"
            v-model="baseParameterModel"
            parameter-type-name="Type"
            :filter-out-list="[3,6,7]"
            return-type="chain"
            :nested-key-name="NestedKeyName"
            :filter-string="filter_string"
          />
        </mosta-tree-select>

        <!-- round -->
        <div v-if="!isEvaluateFormulas"
        class="row justify-between no-wrap q-pa-none q-ma-none">
          <mosta-checkbox
            class="q-my-xs"
            v-model="sectorModel[sector_index].DoRoundParts"
            :label="$t('do_round')"
          />
          <q-input
            class="q-pa-none q-my-xs q-ml-md thin-input"
            v-if="sectorModel[sector_index].DoRoundParts"
            v-model="sectorModel[sector_index].MaxSeparatePartsCount"
            outlined dense
            square
            no-error-icon
            debounce="500"
            hide-bottom-space
          />
        </div>

        <!-- ordering -->
        <div
        class="text-h8 text-bold q-mt-md">
          {{ $t('sorting') }}
        </div>
        <enum-display-list 
          :elements="orderingTypeToList" :enum-to-string="orderingTypeToStr" 
          :allow-multiple="false" :combobox="false" :element-type="8" v-model="orderingModel"/>
        
        <div v-if="!isEvaluateFormulas"
        class="text-h8 text-bold q-mt-md q-mb-none">{{ $t('functions') }}</div>
        <div v-if="!isEvaluateFormulas && genstore.selectedItem.DestType === 6"
        class="text-h8 q-my-none">{{ $t('users_upcase') }}</div>

        <enum-display-list 
          v-if="!isEvaluateFormulas"
          :elements="splitFunctionToList" :enum-to-string="splitFunctionToStr" 
          :allow-multiple="false" :combobox="false" :element-type="8" v-model="sectorSplitModel"/>
          
        <mosta-tree-select
          v-if="isSplitTypeParameter && !isEvaluateFormulas"
          ref="param_select_split"
          :display-text="sectorParameterModelStr"
          :placeholder="$t('select_parameter')"
          :content-max-height="300"
          @update:search="(val) => { filter_string = val; }"
          @keyDown="$refs.rec_selector_split && $refs.rec_selector_split.trackArrowDown(1)"
          @keyUp="$refs.rec_selector_split && $refs.rec_selector_split.trackArrowUp(1)"
          @keyEnter="$refs.rec_selector_split && $refs.rec_selector_split.selectCurrent()"
        >
          <recursive-selector
            ref="rec_selector_split"
            :elements="(theModel as ClientProjectPieTypes).Parameters"
            :take-ids-only="true"
            :allow-multiple="false"
            :element-type="1"
            v-model="sectorParameterModel"
            return-type="chain"
            :nested-key-name="NestedKeyName"
            :filter-string="filter_string"
          />
        </mosta-tree-select>

        <div class="row" v-if="isSplitTypeTags && !isEvaluateFormulas">
          <q-btn
            ref="tagSelectorTriggerBtn"
            class="q-my-none q-pa-none text-left text-md" flat no-caps align="left" size="md" color="grey-8"
            icon="add"
            :aria-label="$t('choose_tags')"
            @click="openTagSelectorMenu"
          >
            <q-tooltip :delay="300" anchor="top middle" self="center middle">
              {{ $t('choose_tags') }}
            </q-tooltip>
          </q-btn>
          <selector-popup
            v-model:visible="isTagSelectorMenuVisible"
            :trigger-el="$refs.tagSelectorTriggerBtn"
            :default-width="300"
          >
            <aux-selector
              :key="tagSelectorKey"
              :filter-model-value="filter_string"
              @update:filter-model-value="onTagFilterUpdate"
              @selectorClosed="closeTagSelectorMenu"
              :model-type="1"
              :limit-height-to-container="true"
              :allow-multiple="true"
              v-model="sectorTagModelForAux"
            />
          </selector-popup>
          <div class="text-h8 q-mt-sm q-ml-sm">
            {{ $t('tags') }}
          </div>
        </div>
        <variable-display-list class="q-mb-sm" 
          v-if="isSplitTypeTags && !isEvaluateFormulas" 
          v-model="sectorTagModel" @itemDeleted="deleteTag" :modelType="1" :modelCategory="1" />

        <q-select
          flat
          v-if="isSplitTypeRoles && ![7, 10, 13].includes(theModel?.Descriptor || 0) && !isEvaluateFormulas"
          v-model="sectorRolesModel"
          class="q-mb-xs"
          hide-bottom-space
          fill-input
          multiple outlined
          option-value="Id"
          option-label="Name"
          :bottom-slots="false"
          dense
          input-debounce="500"
          label=""
          ref="roles_select"
          :options="(theModel as any).WorkerRoles"
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey">
                {{ $t('no_data_found') }}
              </q-item-section>
            </q-item>
          </template>      
        </q-select>

        <!-- isSplitTypeRoles and person / file worker roles -->
        <div v-else-if="isSplitTypeRoles && [10, 13].includes(theModel?.Descriptor || 0) && !isEvaluateFormulas">
          <q-select
            flat
            v-model="workerRoleModelPersonFile"
            hide-bottom-space
            multiple
            :bottom-slots="false"
            dense outlined
            clearable
            input-debounce="500"
            :label="$t('filter_empty')"
            ref="w_rolespf_select"
            :hide-dropdown-icon="false"
            :options="workerRoleOptionsPersonFile"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-grey">
                  {{ $t('no_data_found') }}
                </q-item-section>
              </q-item>
            </template>      
          </q-select>
        </div>

        <!-- isSplitTypeRoles and job worker roles -->
        <div v-else-if="isSplitTypeRoles && theModel?.Descriptor === 7 && !isEvaluateFormulas">
          <q-select
            flat
            v-model="workerRoleModelJob"
            hide-bottom-space
            multiple
            :bottom-slots="false"
            dense outlined
            clearable
            input-debounce="500"
            :label="$t('filter_empty')"
            ref="w_rolespf_select"
            :hide-dropdown-icon="false"
            :options="workerRoleOptionsJob"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-grey">
                  {{ $t('no_data_found') }}
                </q-item-section>
              </q-item>
            </template>      
          </q-select>
        </div>

        <!-- client roles -->
        <MostaSelect
          v-if="isSplitTypeAddressInRole && !isEvaluateFormulas"
          v-model="sectorClientRolesModel"
          class="q-mb-xs"
          option-label="Name"
          :label="$t('clinet_role')"
          :options="(theModel as any).ClientRoles"
        />

        <MostaSelect
          v-if="(isSplitTypeAddressInRole || isSplitTypeAddress) && !isEvaluateFormulas"
          v-model="sectorAddressLevelsModel"
          class="q-mb-xs"
          option-label="Name"
          :label="$t('address_levels')"
          :options="(theModel as any).AddressLevels"
        />

        <!-- job status -->
        <div v-if="isSplitTypeJobStatus && !isEvaluateFormulas">
          <q-select
            flat
            v-model="jobStatusModel"
            class="no-select-border q-mb-xs"
            hide-bottom-space
            multiple
            :bottom-slots="false"
            dense outlined
            input-debounce="500"
            :label="!jobStatusModel || !jobStatusModel.length ? $t('filter_empty') : ''"
            ref="job_status_select"
            :hide-dropdown-icon="false"
            :options="jobStatusOptions"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-grey">
                  {{ $t('no_data_found') }}
                </q-item-section>
              </q-item>
            </template>      
          </q-select>
        </div>

        <div
        v-if="splitHasNumberBorders"
        class="row justify-left q-py-none no-wrap q-my-none items-baseline">
          <div class="text-no-wrap q-mt-sm">{{ '0 < ' }}</div>
          <q-select
            outlined
            dense
            :disable="graphstore.isSaving"
            ref="num_borders"
            v-model="sectorBorderModel"
            use-input
            use-chips
            multiple
            class="q-mx-sm"
            hide-dropdown-icon
            input-debounce="500"
            @new-value="addBorder"
            :placeholder="sectorBorderModel.length ? '' : $t('borders')"
          />
          <div class="text-no-wrap q-mt-sm">{{ ' <' }}</div>
        </div>

        <!-- person / file project count number borders -->
        <div
        v-if="isSplitTypeProjects && !isEvaluateFormulas"
        class="row justify-left q-py-none no-wrap q-my-none items-baseline">
          <div class="text-no-wrap q-mt-sm">{{ '0 < ' }}</div>
          <q-select
            :disable="graphstore.isSaving"
            outlined
            dense
            ref="num_pcount_borders"
            v-model="sectorPCountBorderModel"
            class="q-mx-sm"
            use-input
            use-chips
            multiple
            hide-dropdown-icon
            input-debounce="500"
            @new-value="addPCountBorder"
            :placeholder="sectorPCountBorderModel.length ? '' : $t('participation_borders')"
          />
          <div class="text-no-wrap q-mt-sm">{{ ' <' }}</div>
        </div>

        <!-- spacer div -->
        <div class="q-ma-lg"/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { AnalyticsChartIdentity, PieChartBundleSettingsBase, PieChartSettingsBase } from '@/models/interfaces/entity-settings/charts/charts';
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
import { AnalyticsOrderingType, AnalyticsV2ChartType, AnalyticsV2ElementType, ChartSettingsBaseDescriptor, ClientPieChartSplitType, ClientProjectChartFunction, FilePieChartSplitType, JobPieChartSplitType, JobStatusFilterFlags, JobWorkerRoleFlags, LinearChartFunction, LinearChartStepType, PersonFileWorkerRoleFlags, PersonPieChartSplitType, ProjectPieChartSplitType, StorageItemChartEvaluateFunction, StorageItemChartSplitType, StorageItemMovementChartEvaluateFunction, StorageItemMovementChartSplitType } from '@/models/etc/types';
import EnumDisplayList from '@/components/common/basic/EnumDisplayList.vue';
import DateRangeDisplayItem from '@/components/common/basic/data-components/DateRangeDisplayItem.vue';
import RecursiveSelector from '@/components/common/basic/recursive-selector/refactored/RecursiveSelector.vue';
import { ClientProjectPieTypes, ClientProjectSectorTypes, graphSettingsStore, PieTypes } from '@/store/graph';
import { generalStore } from '@/store/general';
import { rootStore } from '@/store/index';
import { arrayEquals, findRecursive, foreachRecursive } from '@/models/helpers/recursive';
import { storageChartSplitHasNumberBorders, storageChartSplitIsItemNameField } from '@/models/helpers/chart-helpers';
// import TagSelector from '@/components/common/aux-selector/TagSelector.vue';
import VariableDisplayList from '@/components/common/basic/VariableDisplayList.vue';
import { isNumber } from 'lodash';
import { reactive } from 'vue';
import { JobPieChartSettings } from '@/models/interfaces/entity-settings/charts/job-charts';
import { PersonPieChartSettings } from '@/models/interfaces/entity-settings/charts/person-charts';
import { FilePieChartSettings } from '@/models/interfaces/entity-settings/charts/file-charts';
import { CommonEntity } from '@/models/interfaces/common';
import { TouchSwipe } from 'quasar';
import FormulasList from '@/components/common/formulas-list/FormulasList.vue';
import { i18n } from '../../../i18n';
import ElementOptionsSettingsPanel from '../../common/settings-list/ElementOptionsSettingsPanel.vue';
import SelectorPopup from '../../common/aux-selector/SelectorPopup.vue';
import MostaCheckbox from '@/components/common/basic/MostaCheckbox.vue';
import MostaSelect from '@/components/common/MostaSelect.vue';
import MostaTreeSelect from '@/components/common/MostaTreeSelect.vue';

@Component({
  name: 'PieChartPanel',
  components: { EnumDisplayList, VariableDisplayList, DateRangeDisplayItem, 
    RecursiveSelector, FormulasList, ElementOptionsSettingsPanel, SelectorPopup, MostaCheckbox, MostaSelect, MostaTreeSelect }
})
export default class PieChartPanel extends Vue {
  // v-model
  @Prop({ default: {} as PieChartBundleSettingsBase })
  modelValue: any | undefined
  @Emit("update:modelValue") emitModelValue(arg: PieChartBundleSettingsBase | undefined ) { return arg; }

  genstore: any | undefined = undefined
  graphstore: any | undefined = undefined

  selectedId: number = 0
  NestedKeyName = 'RecordFields'
  parameterFieldName = 'ParameterLink';
  filter_string = ''
  menus: any[] = reactive([])
  inputs: any[] = reactive([])

  sectorFormulaModel: any[] = reactive([])
  isEditingMode: boolean = false
  tempName: string = ''
  isTagSelectorMenuVisible = false

  get sector_index() {
    return this.sectorModel.findIndex((el: any) => (el.Id === this.selectedId))
  }

  @Watch('filter_string')
  // change focus from search field to list when up and down arrow keys are pressed
  focusPanel() {
    const that = this
    setTimeout(() => {
      const rec = that.$refs.rec_selector_base || that.$refs.rec_selector_split
      rec && (rec as any).trackArrowDown(1, true)
    }, 100)
  }

  renameBtnClick(level: number) {
    this.tempName = this.sectorModel[level].Name
    const that = this
    this.$nextTick(() => {
      setTimeout(() => {
        // @ts-ignore
        that.inputs[level].select();
      }, 100)
    })
  }

  onTagFilterUpdate(val: string) {
    this.filter_string = val;
  }

  openTagSelectorMenu() {
    this.filter_string = '';
    this.isTagSelectorMenuVisible = true;
  }

  closeTagSelectorMenu() {
    this.isTagSelectorMenuVisible = false;
  }

  // rules
  intRules = [ (val: any) => (!val || !this.isNumeric(val)) || i18n.global.t('enter_integer') ]

  isNumeric(str: string) {
    // if (typeof str != "string") return false // we only process strings!  
    return !isNaN(+str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseInt(str)) // ...and ensure strings of whitespace fail
  }

  created() {
    this.genstore = generalStore()
    this.graphstore = graphSettingsStore()

    if (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.StorageItemPieChart ||
      this.theModel?.Descriptor === ChartSettingsBaseDescriptor.StorageItemMovementPieChart
    ) {
      this.parameterFieldName = 'ParameterLinkForSplit';
    }
  }

  mounted() {
    this.selectedId = -1
  }

  addNewGElement() {
    const request: AnalyticsChartIdentity = {
      ChartId: this.genstore.selectedItem.Id,
      ChartType: this.genstore.selectedItem.elType === 2 ? AnalyticsV2ChartType.Linear : 
        (this.genstore.selectedItem.elType === 3 ? AnalyticsV2ChartType.Pie : AnalyticsV2ChartType.Bar),
      Destination: this.genstore.selectedItem.DestType
    }
    this.graphstore.addGraphElement(request)
  }

  async deleteGElement(del_index: number) {
    const request: AnalyticsChartIdentity = {
      ChartId: this.genstore.selectedItem.Id,
      ChartType: this.genstore.selectedItem.elType === 2 ? AnalyticsV2ChartType.Linear : 
        (this.genstore.selectedItem.elType === 3 ? AnalyticsV2ChartType.Pie : AnalyticsV2ChartType.Bar),
      Destination: this.genstore.selectedItem.DestType
    }
    const deleting_current = (del_index === this.sector_index)
    await this.graphstore.removeGraphElement(this.sectorModel[del_index].Id, this.sectorModel[del_index].Descriptor, request)
    
    const that = this
    this.$nextTick(() => {
      if (deleting_current) {
        if (del_index > 0) {
          that.selectedId = that.sectorModel[del_index-1].Id
        } else if (that.sectorModel.length > 0) {
          that.selectedId = that.sectorModel[0].Id
        } else {
          that.selectedId = -1
        }
      }
    })
  }

  cloneGElement(cl_index: number) {
    const request: AnalyticsChartIdentity = {
      ChartId: this.genstore.selectedItem.Id,
      ChartType: this.genstore.selectedItem.elType === 2 ? AnalyticsV2ChartType.Linear : 
        (this.genstore.selectedItem.elType === 3 ? AnalyticsV2ChartType.Pie : AnalyticsV2ChartType.Bar),
      Destination: this.genstore.selectedItem.DestType
    }
    this.graphstore.cloneGraphElement(this.sectorModel[cl_index].Id, this.sectorModel[cl_index].Descriptor, request)
  }

  async moveFormulaItem(params: any) {
    if (this.graphstore && this.sectorModel && this.sectorModel[this.sector_index]) {
      this.graphstore.changeChartFormulaPosition(params.dragParams.innerElementId, this.sectorModel[this.sector_index].Descriptor,
      this.sectorModel[this.sector_index].Id, params.new_pos)
    }
  }

  renameGElement(ren_index: number) {
    if (this.tempName.length <= 0) { return }
    this.menus[ren_index] && (this.menus[ren_index].hide());

    const request: AnalyticsChartIdentity = {
      ChartId: this.genstore.selectedItem.Id,
      ChartType: this.genstore.selectedItem.elType === 2 ? AnalyticsV2ChartType.Linear : 
        (this.genstore.selectedItem.elType === 3 ? AnalyticsV2ChartType.Pie : AnalyticsV2ChartType.Bar),
      Destination: this.genstore.selectedItem.DestType
    }
    this.graphstore.renameGraphElement(this.sectorModel[ren_index].Id, this.tempName, this.sectorModel[ren_index].Descriptor, request)
  }

  // common pie chart model
  get theModel(): PieChartBundleSettingsBase | undefined {
    return this.modelValue
  }

  set theModel(val: PieChartBundleSettingsBase | undefined) {
    this.emitModelValue(val)
  }

  get isEvaluateFormulas() {
    return (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ClientPieChart || 
           this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ProjectPieChart) && 
           (this.sectorModel[this.sector_index] as ClientProjectSectorTypes).EvaluateFunction === ClientProjectChartFunction.Formulas
  }

  // В сегменте отчётов график лежит как ссылка: его реальное окружение (папка/выборка) там
  // неизвестно, поэтому список анализируемых элементов собрать не из чего. Настраивается
  // только в родном сегменте графика.
  get isReportSegment(): boolean {
    return rootStore().generalMode === AnalyticsV2ElementType.Report
  }

  get isPieChart() {
    return this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ClientPieChart || 
           this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ProjectPieChart ||
           this.theModel?.Descriptor === ChartSettingsBaseDescriptor.StorageItemPieChart ||
           this.theModel?.Descriptor === ChartSettingsBaseDescriptor.StorageItemMovementPieChart
  }

  get isEvaluateParameter() {
    return (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ClientPieChart || 
           this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ProjectPieChart) && 
          (this.sectorModel[this.sector_index] as ClientProjectSectorTypes).EvaluateFunction === ClientProjectChartFunction.ParameterSum
  }

  // pie chart sectors
  get sectorModel(): any {
    if (!this.theModel) { return [] }

    const that = this;
    this.$nextTick(() => {
      setTimeout(() => {
        if (that.selectedId <= 0 && that.sectorModel && that.sectorModel.length) {
          that.selectedId = that.sectorModel[0].Id
        }
      }, 100)
    })

    return (this.theModel as PieTypes).PieCharts
  }

  set sectorModel(val: any) {
    (this.theModel as PieTypes).PieCharts = [...val]
  }

  // placement function
  get axisOptions() {
    return [{
      label: this.$t('pie_horizontal'),
      value: 0
    }, {
      label: this.$t('pie_vertical'),
      value: 1
    }]
  }

  set axisModel(val: any) {
    this.theModel && ((this.theModel as PieChartBundleSettingsBase).DisplayType = val.value)
  }

  get axisModel(): any {
    return this.axisOptions.find(opt => opt.value === (this.theModel as PieChartBundleSettingsBase)?.DisplayType)
  }

  // TODO - Translase
    // width function
    get elementWidthOptions() {
      // multiplier to base size
      return [{
        label: 'x0.25',
        value: 7,
        multiplier: 0.25
      }, {
        label: 'x0.5',
        value: 1,
        multiplier: 0.5
      }, {
        label: 'x0.75',
        value: 2,
        multiplier: 0.75
      }, {
        label: 'x1',
        value: 0,
        multiplier: 1
      }, {
        label: 'x1.25',
        value: 3, // 4 - 1.25
        multiplier: 1.25
      }, {
        label: 'x1.5',
        value: 4,
        multiplier: 1.5
      }, {
        label: 'x1.75',
        value: 5,
        multiplier: 1.75
      }, {
        label: 'x2',
        value: 6,
        multiplier: 2
      }]
    }

    // width function
    get widthOptions() {
      // multiplier to 100% = (value + 1) - value*0.5
      return [{
        label: this.$t('quarter_screen_width'),
        value: 5,
        multiplier: 0.25
      }, {
        label: this.$t('half_screen_width'),
        value: 6,
        multiplier: 0.5
      }, {
        label: this.$t('screen_0_75'),
        value: 7,
        multiplier: 0.75
      }, {
        label: this.$t('screen_width'),
        value: 0,
        multiplier: 1
      }, {
        label: this.$t('screen_1_25'),
        value: 8,
        multiplier: 1.25
      }, {
        label: this.$t('screenup_width'),
        value: 1,
        multiplier: 1.5
      }, {
        label: this.$t('screen_1_75'),
        value: 9,
        multiplier: 1.75
      }, {
        label: this.$t('double_screen_width'),
        value: 2,
        multiplier: 2
      }, {
        label: this.$t('doubleup_screen_width'),
        value: 3,
        multiplier: 2.5
      }, {
        label: this.$t('triple_screen_width'),
        value: 4,
        multiplier: 3
      }]
    }

  set widthModel(val: any) {
    if (!this.theModel || !(this.theModel as PieChartBundleSettingsBase)) { return }
    this.theModel && ((this.theModel as PieChartBundleSettingsBase).ChartWidth = val.value)
  }

  get widthModel(): any {
    return this.widthOptions.find(opt => opt.value === (this.theModel as PieChartBundleSettingsBase)?.ChartWidth)
  }

  set elementWidthModel(val: any) {
    if (!this.theModel || !(this.theModel as PieChartBundleSettingsBase)) { return }
    this.theModel && ((this.theModel as PieChartBundleSettingsBase).ChartElementWidth = val.value)
  }

  get elementWidthModel(): any {
    return this.elementWidthOptions.find(opt => opt.value === (this.theModel as PieChartBundleSettingsBase)?.ChartElementWidth)
  }

  // sector PieChart parameters model for ClientPieChartSettings or ProjectPieChartSettings
  get sectorParameterModel(): any {
    console.log('returning sector parameter model')
    return [this.sectorModel[this.sector_index]?.[this.parameterFieldName]?.IdChain]
  }

  // display selected sector parameter name
  get sectorParameterModelStr(): string {
    const that = this
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index] ||
    !this.sectorModel[this.sector_index][this.parameterFieldName] ||
    !this.sectorModel[this.sector_index][this.parameterFieldName].IdChain ||
    !this.sectorModel[this.sector_index][this.parameterFieldName].IdChain.length) {
      return this.$t('no_parameter_selected')
    }

    const param = findRecursive(function a(element: any, el_to_find: any): any | undefined {
      if (!element) return undefined

      if (arrayEquals([ ...el_to_find.chain, element.Id ], el_to_find.el_to_find)) {
        return element;
      }
      if (element[that.NestedKeyName]) {
        return findRecursive(a, {
          chain: [ ...el_to_find.chain, element.Id ], 
          el_to_find: el_to_find.el_to_find
        }, element[that.NestedKeyName])
      }
      return undefined
    }, { chain: [], el_to_find: this.sectorModel[this.sector_index][this.parameterFieldName].IdChain }, 
    (this.theModel as ClientProjectPieTypes).Parameters)

    return param ? param.Name : this.$t('no_parameter_selected')
  }

  // evaluate function for ClientLinearChartSettings or ProjectLinearChartSettings
  set evaluateModel(val: any) {
    this.sectorModel && this.sectorModel[this.sector_index] && ((this.sectorModel[this.sector_index] as ClientProjectSectorTypes).EvaluateFunction = val)
  }

  get evaluateModel(): any {
    return [(this.sectorModel[this.sector_index] as ClientProjectSectorTypes)?.EvaluateFunction]
  }

  get sectorParameterModelType(): number {
    const that = this
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index] ||
    !this.sectorModel[this.sector_index][this.parameterFieldName] ||
    !this.sectorModel[this.sector_index][this.parameterFieldName].IdChain ||
    !this.sectorModel[this.sector_index][this.parameterFieldName].IdChain.length) {
      return 0
    }

    const param = findRecursive(function a(element: any, el_to_find: any): any | undefined {
      if (!element) return undefined

      if (arrayEquals([ ...el_to_find.chain, element.Id ], el_to_find.el_to_find)) {
        return element;
      }
      if (element[that.NestedKeyName]) {
        return findRecursive(a, {
          chain: [ ...el_to_find.chain, element.Id ], 
          el_to_find: el_to_find.el_to_find
        }, element[that.NestedKeyName])
      }
      return undefined
    }, { chain: [], el_to_find: this.sectorModel[this.sector_index][this.parameterFieldName].IdChain }, 
    (this.theModel as ClientProjectPieTypes).Parameters)

    return param ? param.Type : 0
  }

  set sectorParameterModel(val: any) {
    const next = val?.[0];
    const current = this.sectorModel[this.sector_index]?.[this.parameterFieldName]?.IdChain;
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      this.sectorModel[this.sector_index][this.parameterFieldName] = { IdChain: next }
    }
    if (!arrayEquals(current || [], next || [])) {
      (this.$refs.param_select_split as any)?.close?.();
    }
  }

  // base parameters model for ClientPieChartBundleSettings or ProjectPieChartBundleSettings
  get baseParameterModel(): any {
    return [(this.sectorModel[this.sector_index] as ClientProjectSectorTypes)?.ParameterLinkForEvaluation?.IdChain]
  }

  // display selected parameter name
  get baseParameterModelStr(): string {
    const that = this
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index] ||
    !(this.sectorModel[this.sector_index] as ClientProjectSectorTypes).ParameterLinkForEvaluation ||
    !(this.sectorModel[this.sector_index] as ClientProjectSectorTypes).ParameterLinkForEvaluation.IdChain ||
    !(this.sectorModel[this.sector_index] as ClientProjectSectorTypes).ParameterLinkForEvaluation.IdChain.length) {
      return this.$t('no_parameter_selected')
    }

    const param = findRecursive(function a(element: any, el_to_find: any): any | undefined {
      if (!element) return undefined

      if (arrayEquals([ ...el_to_find.chain, element.Id ], el_to_find.el_to_find)) {
        return element;
      }
      if (element[that.NestedKeyName]) {
        return findRecursive(a, {
          chain: [ ...el_to_find.chain, element.Id ], 
          el_to_find: el_to_find.el_to_find
        }, element[that.NestedKeyName])
      }
      return undefined
    }, { chain: [], el_to_find: (this.sectorModel[this.sector_index] as ClientProjectSectorTypes).ParameterLinkForEvaluation.IdChain }, 
    (this.theModel as ClientProjectPieTypes).Parameters)

    return param ? param.Name : this.$t('no_parameter_selected')
  }

  set baseParameterModel(val: any) {
    const next = val?.[0];
    const current = (this.sectorModel[this.sector_index] as ClientProjectSectorTypes)
      ?.ParameterLinkForEvaluation?.IdChain;
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      (this.sectorModel[this.sector_index] as ClientProjectSectorTypes).ParameterLinkForEvaluation = { IdChain: next }
    }
    if (!arrayEquals(current || [], next || [])) {
      (this.$refs.param_select_base as any)?.close?.();
    }
  }

  // split type function for ClientLinearChartSettings or ProjectLinearChartSettings
  set sectorSplitModel(val: any) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      this.sectorModel[this.sector_index].SplitType = val
    }
  }

  get sectorSplitModel(): any {
    return [this.sectorModel[this.sector_index]?.SplitType]
  }

  // ordering function model
  set orderingModel(val: any) {
    this.sectorModel && this.sectorModel[this.sector_index] && 
      (this.sectorModel[this.sector_index].PartsOrderingType = val)
  }

  get orderingModel(): any {
    return [this.sectorModel && this.sectorModel[this.sector_index].PartsOrderingType]
  }

  get orderingTypeToList() {
    return Object.values(AnalyticsOrderingType).filter((v) => !isNaN(Number(v)))
  }

  orderingTypeToStr(val: number): string {
    switch(val) {
      case AnalyticsOrderingType.Ascending:
        return this.$t('sort_asc')
      case AnalyticsOrderingType.Descending:
        return this.$t('sort_desc')
      case AnalyticsOrderingType.NoOrder:
        return this.$t('do_not_sort')
      default:
        return ""+val
    }
  }

  // job status model
  // job status flags filter
  jobStatusName(arg: number): string {
    switch (arg) {
      case JobStatusFilterFlags.Completed:
        return this.$t('job_done')
      case JobStatusFilterFlags.Lost:
        return this.$t('job_expired')
      case JobStatusFilterFlags.Standard:
        return this.$t('job_is_record')
      case JobStatusFilterFlags.WaitingForCheck:
        return this.$t('job_waiting')
      case JobStatusFilterFlags.Working:
        return this.$t('job_in_progress')
      case JobStatusFilterFlags.Nothing:
      default:
        return this.$t('filter_empty')
    }
  }

  get jobStatusOptions() {
    return Object.values(JobStatusFilterFlags)
      .filter((v) => !isNaN(Number(v)) && Number(v) > 0)
      .map((vm) => {
        return {
          label: this.jobStatusName(Number(vm)),
          value: Number(vm)
        }
      })
  }

  get jobStatusModel() {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      return this.jobStatusOptions.filter((mask: any) => {
        return ((this.sectorModel[this.sector_index] as JobPieChartSettings).JobStatusFlags & mask.value) !== 0
      })
    }
    return []
  }

  set jobStatusModel(mask: any[]) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      (this.sectorModel[this.sector_index] as JobPieChartSettings).JobStatusFlags = 0
      if (!mask || !mask.length) { return }

      mask.forEach(mask => {
        (this.sectorModel[this.sector_index] as JobPieChartSettings).JobStatusFlags |= mask.value;
      })
      
      // console.log((this.sectorModel[this.sector_index] as JobPieChartSettings).JobStatusFlags)
    }
  }

  // person worker role flags
  workerRoleNamePersonFile(arg: number): string {
    switch (arg) {
      case PersonFileWorkerRoleFlags.Creator:
        return this.$t('creator')
      case PersonFileWorkerRoleFlags.LastEditor:
        return this.$t('last_editor')
      case PersonFileWorkerRoleFlags.None:
      default:
        return this.$t('filter_empty')
    }
  }

  get workerRoleOptionsPersonFile() {
    return Object.values(PersonFileWorkerRoleFlags)
      .filter((v) => !isNaN(Number(v)) && Number(v) > 0)
      .map((vm) => {
        return {
          label: this.workerRoleNamePersonFile(Number(vm)),
          value: Number(vm)
        }
      })
  }

  get workerRoleModelPersonFile() {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      return this.workerRoleOptionsPersonFile.filter((mask: any) => {
        return ((this.sectorModel[this.sector_index] as (PersonPieChartSettings | FilePieChartSettings)).WorkerRoleFlags & mask.value) !== 0
      })
    }
    return []
  }

  set workerRoleModelPersonFile(mask: any[]) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      (this.sectorModel[this.sector_index] as (PersonPieChartSettings | FilePieChartSettings)).WorkerRoleFlags = 0
      if (!mask || !mask.length) {
        return
      }

      mask.forEach(mask => {
        (this.sectorModel[this.sector_index] as (PersonPieChartSettings | FilePieChartSettings)).WorkerRoleFlags |= mask.value;
      })
      
      // console.log((this.sectorModel[this.sector_index] as (PersonPieChartSettings | FilePieChartSettings)).WorkerRoleFlags)
    }
  }

  // job worker role flags
  workerRoleNameJob(arg: number): string {
    switch (arg) {
      case JobWorkerRoleFlags.Creator:
        return this.$t('creator')
      case JobWorkerRoleFlags.JobWorker:
        return this.$t('responsible')
      case JobWorkerRoleFlags.None:
      default:
        return this.$t('filter_empty')
    }
  }

  get workerRoleOptionsJob() {
    return Object.values(JobWorkerRoleFlags)
      .filter((v) => !isNaN(Number(v)) && Number(v) > 0)
      .map((vm) => {
        return {
          label: this.workerRoleNameJob(Number(vm)),
          value: Number(vm)
        }
      })
  }

  get workerRoleModelJob() {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      return this.workerRoleOptionsJob.filter((mask: any) => {
        return ((this.sectorModel[this.sector_index] as JobPieChartSettings).WorkerRoleFlags & mask.value) !== 0
      })
    }
    return []
  }

  set workerRoleModelJob(mask: any[]) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      (this.sectorModel[this.sector_index] as JobPieChartSettings).WorkerRoleFlags = 0
      if (!mask || !mask.length) { return }

      mask.forEach(mask => {
        (this.sectorModel[this.sector_index] as JobPieChartSettings).WorkerRoleFlags |= mask.value;
      })
      
      // console.log((this.sectorModel[this.sector_index] as JobPieChartSettings).WorkerRoleFlags)
    }
  }

  // number border values for parameters
  set sectorBorderModel(val: any) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      this.sectorModel[this.sector_index].NumberParameterBorders = val
    }
  }

  get sectorBorderModel(): any {
    return this.sectorModel[this.sector_index]?.NumberParameterBorders || []
  }

  // worker roles model
  set sectorRolesModel(val: any) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      const theonly_index = (val as any[]).findIndex(el => el.TheOnlyOption);
      let val_filtered: any[] = []
      if (theonly_index > -1) {
        // toggle
        if (theonly_index >= 0 && this.sectorModel[this.sector_index].WorkerRoles.includes(val[theonly_index])) {
          val_filtered = val
          val_filtered.splice(theonly_index, 1)
        } else {
          val_filtered = [val[theonly_index]]
        }
      } else {
        val_filtered = val
      }
    
      this.sectorModel[this.sector_index].WorkerRoles = val_filtered
    }
  }

  get sectorRolesModel(): any {
    return this.sectorModel[this.sector_index]?.WorkerRoles || []
  }

  // number border values for parameters
  set sectorPCountBorderModel(val: any) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      this.sectorModel[this.sector_index].ProjectParticipationBorders = val
    }
  }

  get sectorPCountBorderModel(): any {
    return this.sectorModel[this.sector_index]?.ProjectParticipationBorders || []
  }

  addPCountBorder(val: any, done: any) {
    // specific logic to eventually call done(...) -- or not
    if (!isNumber(+val) || Number.isNaN(+val) || this.sectorPCountBorderModel.includes(+val)) { return }

    let insert_index: number = 0;
    for (let a = 0; a < this.sectorPCountBorderModel.length; a++) {
      // console.log('compare'+val+' and '+this.sectorPCountBorderModel[a])
      if (+val < this.sectorPCountBorderModel[a] || a === this.sectorPCountBorderModel.length-1) {
        insert_index = a === this.sectorPCountBorderModel.length-1 && +val >= this.sectorPCountBorderModel[a] ? a+1 : a;
        break;
      }
    }

    if (insert_index > this.sectorPCountBorderModel.length-1) {
      // this adds last
      done(+val, 'add-unique')
    } else {
      this.sectorPCountBorderModel.splice(insert_index, 0, +val);
      // @ts-ignore
      this.$refs.num_pcount_borders.updateInputValue('', true)
    }
  }

  // client roles model
  set sectorClientRolesModel(val: any) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      // console.log('setting client roles model')
      // console.log(val)
      this.sectorModel[this.sector_index].ClientRoleId = val.Id
    }
  }

  get sectorClientRolesModel(): any {
    // console.log((this.theModel as any).ClientRoles)
    if (!this.theModel || !(this.theModel as any).ClientRoles) return undefined
    const found_el = (this.theModel as any).ClientRoles.find((el: any) => el.Id === (this.sectorModel[this.sector_index]?.ClientRoleId || 0))
    // console.log('returning model')
    // console.log(found_el)
    return found_el
  }

  // address levels
  set sectorAddressLevelsModel(val: any) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      this.sectorModel[this.sector_index].AddressLevelId = val.Id
    }
  }

  get sectorAddressLevelsModel(): any {
    if (!this.theModel || !(this.theModel as any).AddressLevels) return undefined
    const found_el = (this.theModel as any).AddressLevels.find((el: any) => el.Id === (this.sectorModel[this.sector_index]?.AddressLevelId || 0))
    // console.log('returning model')
    // console.log(found_el)
    return found_el
  }

  // analyzed element
  set sectorAnalyzedModel(val: any) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      this.sectorModel[this.sector_index].AnalyzedElementIdentity = val?.Identity ?? null

      if (val?.Name) {
        this.tempName = val.Name;
        let add_i = 0;
        while (this.sectorModel.findIndex((s: CommonEntity) => s.Name === this.tempName) > 0) {
          add_i++;
          this.tempName = val.Name + add_i;
        }
        this.renameGElement(this.sector_index);
      }
    }
  }

  get sectorAnalyzedModel(): any {
    if (!this.theModel || !this.genstore.analyzedListForChart) return undefined
    const identity = this.sectorModel[this.sector_index]?.AnalyzedElementIdentity
    if (!identity) return undefined
    const found_el = this.genstore.analyzedListForChart.find((el: any) => {
      const i = el?.Identity
      return i &&
        i.ElementId === identity.ElementId &&
        i.Kind === identity.Kind &&
        (i.Source ?? null) === (identity.Source ?? null) &&
        i.Destination === identity.Destination
    })
    // console.log('returning model')
    // console.log(found_el)
    return found_el
  }

  @Watch('theModel.EvaluateFunction', { deep: true })
  first_parameter_base_setter(arg: any) {
    if (this.theModel && arg === 1 && 
      (this.theModel.Descriptor === 1 || this.theModel.Descriptor === 4)) {
      if (!this.baseParameterModel || !this.baseParameterModel.length || !this.baseParameterModel[0]) {
        const that = this
        setTimeout(() => {
          // find first appropriate parameter
          let first_found_param_chain: any = undefined
          foreachRecursive(function a(element: any, el_to_find: any): any | undefined {
            if (first_found_param_chain || !element) return
            
            if (![3,6,7,8].includes(element.Type)) {
              first_found_param_chain = [ ...el_to_find, element.Id ]
            }

            if (!first_found_param_chain && element.RecordFields) {
              foreachRecursive(a, [ ...el_to_find, element.Id ], element.RecordFields)
            }
            return
          }, [], (that.theModel as ClientProjectPieTypes).Parameters)
          
          if (first_found_param_chain) {
            that.baseParameterModel = [first_found_param_chain]
          }
        }, 100)
      }
    }
  }

  @Watch('isSplitTypeParameter', { deep: true })
  first_parameter_split_setter(arg: boolean) {
    if (arg) {
      // console.log('find appropriate')
      // console.log(this.sectorParameterModel)
      // find first appropriate parameter
      if (!this.sectorParameterModel || !this.sectorParameterModel.length || !this.sectorParameterModel[0]) {
        let first_found_param_chain: any = undefined
        foreachRecursive(function a(element: any, el_to_find: any): any | undefined {
          if (first_found_param_chain || !element) return
          
          if (![8].includes(element.Type)) {
            first_found_param_chain = [ ...el_to_find, element.Id ]
          }

          if (!first_found_param_chain && element.RecordFields) {
            foreachRecursive(a, [ ...el_to_find, element.Id ], element.RecordFields)
          }
          return
        }, [], (this.theModel as ClientProjectPieTypes).Parameters)
        
        if (first_found_param_chain) {
          this.sectorParameterModel = [first_found_param_chain]
        }
      }
    }
  }

  addBorder(val: any, done: any) {
    // specific logic to eventually call done(...) -- or not
    if (!isNumber(+val) || Number.isNaN(+val) || this.sectorBorderModel.includes(+val)) { return }

    let insert_index: number = 0;
    for (let a = 0; a < this.sectorBorderModel.length; a++) {
      // console.log('compare'+val+' and '+this.sectorBorderModel[a])
      if (+val < this.sectorBorderModel[a] || a === this.sectorBorderModel.length-1) {
        insert_index = a === this.sectorBorderModel.length-1 && +val >= this.sectorBorderModel[a] ? a+1 : a;
        break;
      }
    }

    if (insert_index > this.sectorBorderModel.length-1) {
      // this adds last
      done(+val, 'add-unique')
    } else {
      this.sectorBorderModel.splice(insert_index, 0, +val);
      // @ts-ignore
      this.$refs.num_borders.updateInputValue('', true)
    }
  }

  // tag model for PieChartSettings
  get sectorTagModel(): any {
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index] ||
    !this.sectorModel[this.sector_index].Tags) {
      return []
    }

    return this.sectorModel[this.sector_index]?.Tags
  }

  set sectorTagModel(val: any) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      this.sectorModel[this.sector_index].Tags = val ? val : []
    }
  }

  get sectorTagModelForAux(): any[] {
    return (this.sectorTagModel || []).map((item: any) => (
      item?.Entity ? item : { Entity: item }
    ));
  }

  set sectorTagModelForAux(val: any[]) {
    this.sectorTagModel = (val || []).map((item: any) => item?.Entity ?? item);
  }

  get tagSelectorKey(): string {
    return `${rootStore().generalMode}-${this.sector_index}`;
  }

  deleteTag(d_index: number) {
    if (this.sectorModel && this.sectorModel[this.sector_index]) {
      this.sectorModel[this.sector_index].Tags.splice(d_index, 1)
    }
  }

  // evaluate function
  get evaluateToList() {
    switch (this.theModel?.Descriptor) {
      case ChartSettingsBaseDescriptor.StorageItemPieChart:
        return Object.values(StorageItemChartEvaluateFunction).filter((v) => !isNaN(Number(v)));
      case ChartSettingsBaseDescriptor.StorageItemMovementPieChart:
        return Object.values(StorageItemMovementChartEvaluateFunction).filter((v) => !isNaN(Number(v)));
      default:
        return Object.values(ClientProjectChartFunction).filter((v) => !isNaN(Number(v)));
    }
  }

  EvaluateFunctionToStr(val: number): string {
    switch (this.theModel?.Descriptor) {
      case ChartSettingsBaseDescriptor.StorageItemPieChart:
        switch(val) {
          case StorageItemChartEvaluateFunction.ItemsCount:
            return this.$t('unique_items')
          case StorageItemChartEvaluateFunction.ItemsInStockQuantity:
            return this.$t('warehouse_items')
          case StorageItemChartEvaluateFunction.ItemsInStockTotalAmount:
            return this.$t('warehouse_value')
          case StorageItemChartEvaluateFunction.FinancialBurden:
            return this.$t('financial_load')
          default:
            return ""+val
        }
      case ChartSettingsBaseDescriptor.StorageItemMovementPieChart:
        switch(val) {
          case StorageItemMovementChartEvaluateFunction.ItemsQuantity:
            return this.$t('count_type')
          case StorageItemMovementChartEvaluateFunction.MovementsCount:
            return this.$t('actions_count')
          case StorageItemMovementChartEvaluateFunction.TotalAmount:
          return this.$t('totalamount_type')
          default:
            return ""+val
        }
      default:
        switch(val) {
          case ClientProjectChartFunction.Count:
            return this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ClientPieChart ? 
            this.$t('clients_count') : this.$t('projects_on_stage_count')
          case ClientProjectChartFunction.ParameterSum:
            return this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ClientPieChart ? 
            this.$t('clients_parameter_sum') : this.$t('projects_parameter_sum')
          case ClientProjectChartFunction.Formulas:
            return this.$t('formulas_label')
          default:
            return ""+val
        }
    }
  }
    
  get splitFunctionToList() {
    switch (this.theModel?.Descriptor) {
      case ChartSettingsBaseDescriptor.ClientPieChart:
        return Object.values(ClientPieChartSplitType).filter((v) => !isNaN(Number(v)))
      case ChartSettingsBaseDescriptor.ProjectPieChart:
        return Object.values(ProjectPieChartSplitType).filter((v) => !isNaN(Number(v)))
      case ChartSettingsBaseDescriptor.JobPieChart:
        return Object.values(JobPieChartSplitType).filter((v) => !isNaN(Number(v)))
      case ChartSettingsBaseDescriptor.FilePieChart:
        return Object.values(FilePieChartSplitType).filter((v) => !isNaN(Number(v)))
      case ChartSettingsBaseDescriptor.PersonPieChart:
        return Object.values(PersonPieChartSplitType).filter((v) => !isNaN(Number(v)))
      case ChartSettingsBaseDescriptor.StorageItemPieChart:
        return Object.values(StorageItemChartSplitType).filter((v) => !isNaN(Number(v)))
      case ChartSettingsBaseDescriptor.StorageItemMovementPieChart:
        return Object.values(StorageItemMovementChartSplitType).filter((v) => !isNaN(Number(v)))
      default:
        return []
    }
  }

  // split types are different across data segments
  get isSplitTypeParameter(): boolean {
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index]) {
      return false
    }

    return (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ClientPieChart &&
        this.sectorModel[this.sector_index].SplitType === ClientPieChartSplitType.Parameter) ||
      (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ProjectPieChart &&
        this.sectorModel[this.sector_index].SplitType === ProjectPieChartSplitType.Parameter) ||
      storageChartSplitIsItemNameField(this.theModel?.Descriptor,
        this.sectorModel[this.sector_index].SplitType)
  }

  get splitHasNumberBorders(): boolean {
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index]) {
      return false
    }

    return (!(this.theModel?.Descriptor === ChartSettingsBaseDescriptor.StorageItemPieChart ||
      this.theModel?.Descriptor === ChartSettingsBaseDescriptor.StorageItemMovementPieChart) && 
      this.isSplitTypeParameter && [0,1,2,4,5].includes(this.sectorParameterModelType)
      || 
      storageChartSplitHasNumberBorders(this.theModel?.Descriptor,
        this.sectorModel[this.sector_index].SplitType))

       && !this.isEvaluateFormulas
  }

  get hasAnalyticElementOptions(): boolean {
    if (!this.theModel) {
      return false
    }
    return this.theModel?.Descriptor === ChartSettingsBaseDescriptor.StorageItemMovementPieChart
  }

  // split types are different across data segments
  get isSplitTypeTags(): boolean {
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index]) {
      return false
    }

    return (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ClientPieChart &&
        this.sectorModel[this.sector_index].SplitType === ClientPieChartSplitType.Tags) ||
      (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ProjectPieChart &&
        this.sectorModel[this.sector_index].SplitType === ProjectPieChartSplitType.Tags) ||
      (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.JobPieChart &&
        this.sectorModel[this.sector_index].SplitType === JobPieChartSplitType.Tags) ||
      (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.FilePieChart &&
        this.sectorModel[this.sector_index].SplitType === FilePieChartSplitType.Tags) ||
      (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.PersonPieChart &&
        this.sectorModel[this.sector_index].SplitType === PersonPieChartSplitType.Tags)
  }

  get isSplitTypeProjects(): boolean {
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index]) {
      return false
    }

    return (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.PersonPieChart &&
      this.sectorModel[this.sector_index].SplitType === PersonPieChartSplitType.ParticipationInProjects)
  }

  // split types are different across data segments
  get isSplitTypeRoles(): boolean {
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index]) {
      return false
    }

    return (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ClientPieChart &&
        this.sectorModel[this.sector_index].SplitType === ClientPieChartSplitType.WorkerInRole) ||
      (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ProjectPieChart &&
        this.sectorModel[this.sector_index].SplitType === ProjectPieChartSplitType.WorkerInRole) ||
      (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.JobPieChart &&
        this.sectorModel[this.sector_index].SplitType === JobPieChartSplitType.WorkerInRole) ||
      (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.FilePieChart &&
        this.sectorModel[this.sector_index].SplitType === FilePieChartSplitType.WorkerInRole) ||
      (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.PersonPieChart &&
        this.sectorModel[this.sector_index].SplitType === PersonPieChartSplitType.WorkerInRole)
  }

  // split types are different across data segments
  get isSplitTypeAddress(): boolean {
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index]) {
      return false
    }

    return (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ClientPieChart &&
        this.sectorModel[this.sector_index].SplitType === ClientPieChartSplitType.Address) ||
      (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.PersonPieChart &&
        this.sectorModel[this.sector_index].SplitType === PersonPieChartSplitType.Address)
  }

  // split types are different across data segments
  get isSplitTypeAddressInRole(): boolean {
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index]) {
      return false
    }

    return (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.ProjectPieChart &&
      this.sectorModel[this.sector_index].SplitType === ProjectPieChartSplitType.AddressInRole) ||
    (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.JobPieChart &&
      this.sectorModel[this.sector_index].SplitType === JobPieChartSplitType.AddressInRole) ||
    (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.FilePieChart &&
      this.sectorModel[this.sector_index].SplitType === FilePieChartSplitType.AddressInRole)
  }

  // split types are different across data segments
  get isSplitTypeJobStatus(): boolean {
    if (!this.sectorModel ||
    !this.sectorModel[this.sector_index]) {
      return false
    }

    return (this.theModel?.Descriptor === ChartSettingsBaseDescriptor.JobPieChart &&
      this.sectorModel[this.sector_index].SplitType === JobPieChartSplitType.Status)
  }

  splitFunctionToStr(val: number): string {
    switch (this.theModel?.Descriptor) {
      case ChartSettingsBaseDescriptor.ClientPieChart:
        switch(val) {
          case ClientPieChartSplitType.Address:
            return this.$t('split_client_address')
          case ClientPieChartSplitType.WorkerInRole:
            return this.$t('split_user')
          case ClientPieChartSplitType.Tags:
            return this.$t('split_tags')
          case ClientPieChartSplitType.Parameter:
            return this.$t('split_parameter')
          case ClientPieChartSplitType.Owner:
            return this.$t('split_owner')
          default:
            return ""+val
        }
      case ChartSettingsBaseDescriptor.ProjectPieChart:
        switch(val) {
          case ProjectPieChartSplitType.AddressInRole:
            return this.$t('split_client_role_address')
          case ProjectPieChartSplitType.WorkerInRole:
            return this.$t('split_user')
          case ProjectPieChartSplitType.Tags:
            return this.$t('split_tags')
          case ProjectPieChartSplitType.Stages:
            return this.$t('split_stages')
          case ProjectPieChartSplitType.Parameter:
            return this.$t('split_parameter')
          case ProjectPieChartSplitType.Owner:
            return this.$t('split_owner')
          default:
            return ""+val
        }
      case ChartSettingsBaseDescriptor.JobPieChart:
        switch(val) {
          case JobPieChartSplitType.AddressInRole:
            return this.$t('split_client_role_address')
          case JobPieChartSplitType.WorkerInRole:
            return this.$t('split_user')
          case JobPieChartSplitType.Tags:
            return this.$t('split_tags')
          case JobPieChartSplitType.Status:
            return this.$t('split_status')
          default:
            return ""+val
        }
      case ChartSettingsBaseDescriptor.FilePieChart:
        switch(val) {
          case FilePieChartSplitType.AddressInRole:
            return this.$t('split_role_address')
          case FilePieChartSplitType.WorkerInRole:
            return this.$t('split_user')
          case FilePieChartSplitType.Tags:
            return this.$t('split_tags')
          default:
            return ""+val
        }
      case ChartSettingsBaseDescriptor.PersonPieChart:
        switch(val) {
          case PersonPieChartSplitType.Address:
            return this.$t('split_client_address')
          case PersonPieChartSplitType.WorkerInRole:
            return this.$t('split_user')
          case PersonPieChartSplitType.Tags:
            return this.$t('split_tags')
          case PersonPieChartSplitType.ParticipationInProjects:
            return this.$t('split_projects_participation')
          default:
            return ""+val
        }
      case ChartSettingsBaseDescriptor.StorageItemPieChart:
        switch(val) {
          case StorageItemChartSplitType.Storage:
            return this.$t('item_warehouse')
          case StorageItemChartSplitType.FinancialBurden:
            return this.$t('financial_burden_type')
          case StorageItemChartSplitType.ItemNameField:
            return this.$t('item_name_field')
          case StorageItemChartSplitType.ItemsQuantity:
            return this.$t('warehouse_qty')
          case StorageItemChartSplitType.SingleItemPrice:
            return this.$t('item_price')
          case StorageItemChartSplitType.Creator:
            return this.$t('responsible_worker')
          case StorageItemChartSplitType.TotalAmount:
            return this.$t('warehouse_total')
          default:
            return ""+val
        }
      case ChartSettingsBaseDescriptor.StorageItemMovementPieChart:
        switch(val) {
          case StorageItemMovementChartSplitType.ItemNameField:
            return this.$t('item_name_field')
          case StorageItemMovementChartSplitType.ItemsQuantity:
            return this.$t('warehouse_qty')
          case StorageItemMovementChartSplitType.ReceiverStorage:
            return this.$t('receiver_storage')
          case StorageItemMovementChartSplitType.SingleItemPrice:
            return this.$t('item_price')
          case StorageItemMovementChartSplitType.SourceStorage:
            return this.$t('source_storage')
          case StorageItemMovementChartSplitType.Creator:
            return this.$t('responsible_worker')
          case StorageItemMovementChartSplitType.TotalAmount:
            return this.$t('warehouse_total')
          default:
            return ""+val
        }
      default:
        return ''
    }
  }
}
</script>

<style lang="scss">
.q-btn__content > span {
  text-align: left !important;
}
</style>